import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Image,
} from "@chakra-ui/react";
import { Dispatch, SetStateAction } from "react";
import { AiOutlineDownload } from "react-icons/ai";

interface Props {
  url: string;
  setUrl: Dispatch<SetStateAction<string>>;
}

export function OriginalSizePhoto({ url, setUrl }: Props) {
  const handleClose = () => {
    setUrl("");
  };

  const handleDownload = () => {
    const newWindow = window.open(url);
  };
  return (
    <Modal
      onClose={handleClose}
      size="xl"
      isOpen={Boolean(url)}
      scrollBehavior="outside"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Tamanho original</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Image src={url} />
        </ModalBody>
        <ModalFooter justifyContent="space-between">
          <Button leftIcon={<AiOutlineDownload />} onClick={handleDownload}>
            Download
          </Button>
          <Button onClick={handleClose}>Fechar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
